import React, { useState, useEffect, ReactNode } from 'react';
import { Box, Text, Button, Flex } from '@chakra-ui/react';

interface ErrorBoundaryProperties {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorState {
  hasError: boolean;
  error?: Error;
}

const ErrorBoundary: React.FC<ErrorBoundaryProperties> = ({ children, fallback }) => {
  const [errorState, setErrorState] = useState<ErrorState>({ hasError: false });

  useEffect(() => {
    const handleError = (error: Error, errorInfo: any) => {
      console.error('ErrorBoundary caught an error:', error, errorInfo);
      setErrorState({ hasError: true, error });
    };

    // Add global error handler
    // window.addEventListener('error', (event) => {
    //   handleError(event.error || new Error('Unknown error'), event);
    // });

    // Add unhandled promise rejection handler
    // window.addEventListener('unhandledrejection', (event) => {
    //   handleError(new Error(event.reason), event);
    // });

    return () => {
      window.removeEventListener('error', handleError as any);
      window.removeEventListener('unhandledrejection', handleError as any);
    };
  }, []);

  const handleReset = () => {
    setErrorState({ hasError: false });
  };

  if (errorState.hasError) {
    if (fallback) {
      return <>{fallback}</>;
    }

    return (
      <Box p={4} border='1px solid' borderColor='red.200' borderRadius='md' bg='red.50'>
        <Flex direction='column' align='center' gap={3}>
          <Text fontSize='lg' fontWeight='bold' color='red.600'>
            Something went wrong
          </Text>
          <Text fontSize='sm' color='gray.600' textAlign='center'>
            {errorState.error?.message || 'An unexpected error occurred'}
          </Text>
          <Button size='sm' colorScheme='red' onClick={handleReset}>
            Try Again
          </Button>
        </Flex>
      </Box>
    );
  }

  return <>{children}</>;
};

export default ErrorBoundary;
